import React from "react";
import VisitorTable2 from "./common/visitorTable2";
import { Form, Row, Col } from 'react-bootstrap';
import {
    Home,
    CaretRight,
    TrendingDown,
    Notebook,
    List,
    ClipboardCheck,
    BuildingHospital,
    CalendarEvent
} from 'tabler-icons-react';
import VisitorList2 from './common/visitorlist2';
import leftArrow from '../images/leftArrow.png'
import righttArrow from '../images/rightArrow.png'
import btnHome from '../images/btnHomeIcon.png'
import iconFinish from '../images/iconFinish.png'


const ApptSummary = () => {
    return (
        <div className="topicSection">

            {/* HOME BUTTON SECTION */}
            <div className="btnHomeSection bounce-in-fwd10">
                <button type="button" className="btnCircle">
                    <img src={btnHome} alt="Date" height="50" width="50" /><br />
               HOME
            </button>
            </div>

            <div className="headerSub">
                <div className="headerSubTitle headerSubLineTop scale-in-center">
                    <p>
                        PLEASE ENTER THE APPOINTMENT PATIENT’S DETAILS
                    </p>
                </div>
            </div>

            <div className="headerName">
                <div className="headerTitle slide-in-top">
                    <div className="iconAppt"></div>
                    <div className="iconNameTitle">APPOINTMENT VISIT</div>
                </div>
            </div>


            {/* MAIN CONTENT SECTION */}
            <div className="contentPage">

                {/* BREADCRUMBS */}
                <div className="breadcrumbs">
                    <ul>
                        <li className="fcolorGreen"><Home size={50} strokeWidth={2} color={'green'} /> <span className="crumHome">HOME </span>
                            <TrendingDown size={25} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen"><CalendarEvent size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 1</i></b>
                            <br />
                        APPOINTMENT VISIT <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen "><Notebook size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 2</i></b> <br />
                        REGISTRATION <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorRed"><List size={40} strokeWidth={2} color={'red'} />
                            <b><i> Step 3</i></b> <br />
                        SUMMARY <CaretRight size={40} strokeWidth={2} color={'red'} />
                        </li>
                        <li className="fcolorGray"><ClipboardCheck size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 4</i></b> <br />
                        COMPLETE

                        {/* For White space */}
                            <CaretRight size={40} strokeWidth={2} color={'transparent'} />
                        </li>
                    </ul>

                </div>

                {/* FORM SECTION  */}
                <div className="formSection">
                    <h2 className="fade-in-tl5"><b>SUMMARY REGISTRATION</b></h2>
                    <br />
                    <Form>
                        <Form.Group as={Row} controlId="formGroupPatientFname" className="fade-in-tl6">
                            <Form.Label column sm="4">Reason for visit</Form.Label>
                            <Col sm="8">
                                <Form.Control as="textarea" rows={3} size="lg" placeholder="Accompanying Appointment Patient" />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formGroupPatientBed" className="fade-in-tl10">
                            <Form.Label column sm="4">Patient's info</Form.Label>
                            <Col sm="8">
                                <Form.Control type="input" size="lg" placeholder="Tan Ah kow, W99, R34, B99" />
                            </Col>
                        </Form.Group>
                    </Form>
                </div>


                <div className="footerBtnLeft fade-in-left7">
                    <button type="button" className="btnCircle">
                        <img src={leftArrow} alt="Arrow Left" height="50" width="50" /><br />
                        BACK
                    </button>
                </div>

                {/* COMPLETE BUTTON */}
                <div className="footerBtnRight fade-in-left8">
                    <button type="button" className="btnCircleGreen">
                        <img src={iconFinish} alt="Arrow Right" height="50" width="50" /><br />
                        FINISH
                    </button>
                </div>


                {/* VISITOR LIST SECTION */}
                <VisitorList2 />


                {/* VISITOR TABLE */}
                <VisitorTable2 />

            </div>
        </div>
    );
};

export default ApptSummary;